import "core-js/modules/web.dom-collections.iterator.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import 'assets/styles/app.scss';
const loadedComponents = [];
document.addEventListener('DOMContentLoaded', /*#__PURE__*/_asyncToGenerator(function* () {
  /**
   * Bootstrap the components
   */
  for (const dataComponent of document.querySelectorAll('[data-component]')) {
    let componentName = dataComponent.dataset.component;

    if (loadedComponents.indexOf(componentName) === -1) {
      loadedComponents.push(componentName);

      try {
        let component = yield import(
        /* WebpackMode: "lazy" */

        /* webpackPrefetch: true */

        /* webpackPreload: true */
        "components/".concat(componentName, "/").concat(componentName, ".js"));
        component.default();
      } catch (error) {
        console.error('Loading error: ', error);
      }
    }
  }
}));